import React, {useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { configure, getConfiguration } from '../../actions/Settings'

import { useSelector } from 'react-redux'
import ChatRouter from  './ChatRouter'


// ---------------------
// Component 
// ---------------------

const ChatRoom = (props) => {

    const dispatch = useDispatch();

    // Setup the Chat Room
    useEffect(() => { 

        // Get Configuration
        dispatch(configure(props.site));
        dispatch(getConfiguration());

    }, []);

    // -----------------------
    // TCC Plan Validation
    // -----------------------

    const settings = useSelector(state => state.Settings);
    if(!settings) return (<div>Loading...</div>)
    if(settings.plan === 'website_basic') return (<div>Please upgrade your account to access this feature</div>)
    
    // Admin Access
    const isAdmin = !!settings.user; 

    // Show Chat
    return (
        <ChatRouter room={props.room} isAdmin={isAdmin} />
    )

}

export default ChatRoom;
